import React, { useEffect } from 'react';
import { Subject } from "rxjs";
import { FormPane } from "../../components/FormZero/PageComponents/FormPane/FormPane";
import { DataGridPro as DataGrid, GridColDef } from '@mui/x-data-grid-pro';
import axios from "axios";
import { Button } from "../../components/FormZero/Button/Button";
import { Button as MUIButton, Dialog, DialogActions, DialogContent, DialogContentText, DialogTitle, ThemeProvider, createTheme } from '@mui/material';
import { ActionPanel } from "../../components/FormZero/ActionPanel/ActionPanel";
import * as XLSX from "xlsx";
import { TextField } from "@mui/material";
import SearchChips from '../../components/SearchChips';
import { ISearchChips } from '../../interfaces/Core/ISearchChips';
import ActionMenu from '../../components/ActionMenu';
import ActionButton from '../../components/ActionButton';
import { CustomDataGrid } from '../../components/StripedDataGrid'
import { useAppDispatch } from '../../hooks';
import { IApplication } from '../../interfaces/IApplication';
import { setPageTitle } from '../../slices/applicationSlice';


function PanelView(props: { dataSource: any; selectedRows: any; }) {
    const { dataSource, selectedRows } = props;


    





    return (
        <>
            <div className="SprayRecordsGrid_PanelView">
                {/*PanelContents*/}
                <div className="row">
                    <div className="col-6">

                    </div>
                    <div className="col-6">

                    </div>
                </div>

            </div>
        </>
    )
}

function ChangeStatusDialog(props: { cellValues: any; isLoadingCompleted: any; updateUI: any; }) {
    const { cellValues, isLoadingCompleted, updateUI } = props;

    const [isOpen, setOpen] = React.useState(false);
    const onCellEditCommit = async (cellEdit: { id: any; field: any; value: any; }) => {
        console.log(cellEdit);
        let data = { field: cellEdit.field, value: cellEdit.value };
        const resp = await axios.put(
            `/seeding/status/${cellEdit.id}`,
            data
        );
        await updateUI();
        setOpen(false);
        console.log(resp);
    }

    const buttons = [
        {
            value: 0,
            label: "Canceled"
        },
        {
            value: 1,
            label: "Ordered Unverified"
        },
        {
            value: 2,
            label: "Verified"
        },
    ];

    return (<>
        <MUIButton fullWidth={true} disabled={isLoadingCompleted} variant={'contained'} color={"secondary"} onClick={() => setOpen(true)}>Status: {cellValues.row.comment !== null ? cellValues.row.comment : "OK"}</MUIButton>
        <Dialog
            open={isOpen}
            onClose={() => setOpen(false)}
            aria-labelledby="alert-dialog-title"
            aria-describedby="alert-dialog-description"
        >
            <DialogTitle id="alert-dialog-title">
                Change Status
            </DialogTitle>
            <DialogContent style={{ width: '500px', textAlign: 'center' }}>
                <DialogContentText id="alert-dialog-description">
                    {cellValues.row.species} - {cellValues.row.class} - {cellValues.row.variety}
                </DialogContentText>
                <div style={{ display: 'flex', flexDirection: 'row', gap: '1rem' }}>
                    {buttons.map((btn) => {
                        return (<MUIButton disabled={isLoadingCompleted} fullWidth={true} variant={'contained'} color={"secondary"} onClick={() => {
                            onCellEditCommit({
                                id: cellValues.id,
                                field: "is_ordered",
                                value: btn.value
                            }).then(() => {
                                setOpen(false)
                            })
                        }}>{btn.label}</MUIButton>);
                    })}
                </div>

            </DialogContent>
            <DialogActions>
                <MUIButton onClick={() => setOpen(false)}>Close</MUIButton>
            </DialogActions>
        </Dialog>
    </>)
}

export function OrderSeed(props: any) {
    const dispatch = useAppDispatch();

    useEffect(() => {

        let appState: IApplication = {
            pageTitle: "Order Seed"
        }
        dispatch(setPageTitle(appState));
    }, []);
    const { } = props;


    const filterFormStructure = [
        { key: "week_year", type: "week-filter", size: { default: 4 }, label: "Week", required: true },
        { key: "week_year_view", type: "header", size: { default: 4 }, valueKey: "week_year" },
    ];
    const filterFormSubject = new Subject();
    const [formFilter, setFormFilter] = React.useState({});
    filterFormSubject.subscribe((n: any) => setFormFilter(n));


    const columns: GridColDef[] = [
        // tray size,
        { field: "traySize", headerName: "Tray Size", width: 100 },
        // preffered packet size,
        { field: "packetSize", headerName: "Packet Size", width: 200 },
        // seeds per cell,
        { field: "seedsPerCell", headerName: "Seeds Per Cell", width: 200 },
        // seed type,
        { field: "seedType", headerName: "Seed Type", width: 100, align: 'center' },
        // ordered by,
        { field: "orderedBy", headerName: "Ordered By", width: 150 },
        // status,
        { field: "status", headerName: "Status", width: 200 },
        // notes,
        { field: "notes", headerName: "Notes", width: 200 },
        // quantity,
        { field: "quantity", headerName: "Quantity", width: 200 },

        // quantity to order,
        { field: "quantity_to_order", headerName: "Quantity To Order", width: 200 },
        // number of trays,
        { field: "numberOfTrays", headerName: "Number Of Trays", width: 200 },
        // tray type,
        { field: "trayType", headerName: "Tray Type", width: 200 },

        // ball,
        { field: "ball", headerName: "Ball", width: 200 },
        // substitute,
        { field: "substitute", headerName: "Substitute", width: 200 },

        // description,
        { field: "description", headerName: "Description", width: 200 },
        // vbm description,
        { field: "vbm_description", headerName: "VBM Description", width: 200 },
        // ship week,
        { field: "ship_week", headerName: "Ship Week", width: 200 },
        // sow week,
        { field: "sow_week", headerName: "Sow Week", width: 200 },
        // customer,
        { field: "customer", headerName: "Customer", width: 200 },
        // order date,
        { field: "order_date", headerName: "Order Date", width: 200 },

        // vendor.
        { field: "vendor", headerName: "Vendor", width: 200 },






        // {field: "row_debug", headerName: "Debug", width: 800, renderCell: (cellValues) => { return <pre>{JSON.stringify(cellValues.row)}</pre> } },
        // {field: "broker_material_number", headerName: "Ball", width: 200},
        // // {field: "vendor_material_number", headerName: "Vendor", width: 200},
        // {field: "createdAt", headerName: "Order Date", width: 200},
        // // {field: "sold_name", headerName: "Customer", width: 200},
        // {field: "sow_week", headerName: "Sow Week", width: 200},
        // // {field: "ship_week", headerName: "Ship Week", width: 200},
        // {field: "ship_week", headerName: "Ship Week", width: 200},
        // // {field: "vbm_description", headerName: "VBM Description", width: 200},
        // {field: "material_description", headerName: "Description", width: 200},
        // // {field: "ship_week", headerName: "Ship Week", width: 200},
        // {field: "is_ordered", headerName: "Is Ordered", width: 200},
        // {field: "number_of_tray", headerName: "Number Of Trays", width: 200},
        // {field: "quantity", headerName: "Quantity", width: 200},
        // {field: "quantity_to_order", headerName: "Quantity To Order", width: 200},
        // {field: "notes", headerName: "Notes", width: 200},
        // {field: "Status", headerName: "Status", width: 200},
        // {field: "actions", headerName: "Actions", width: 200},
        {
            field: "status_btn", headerName: " ", width: 200,
            renderCell: (cellValues: any) => {
                return (<ChangeStatusDialog cellValues={cellValues} isLoadingCompleted={false} updateUI={loadData} />);
            }
        },
    ]

    const [selectionModal, setSelectionModal] = React.useState<any>([]);

    const [rows, setRows] = React.useState<any>([]);
    const [page, setPage] = React.useState(1);
    const loadData = async () => {
        try {
            const response = await axios.get(`${process.env.REACT_APP_ENDPOINT}/api/SeedDemandDetails`);
            setRows(response.data);

            // TODO process this to merge them by seed species....
            console.table(response.data);

            // setRows(response.data.data);
            //               setCurrentPage(response.data.current_page);
            //                 setTotalPage(response.data.total);
        } catch (e) {
            console.error(e);
        }
    };
    React.useEffect(() => {
        loadData().then();
    }, [])

    const panel = (<PanelView dataSource={rows} selectedRows={selectionModal} />);

    const darkTheme = createTheme({
        palette: {
            mode: 'dark',
            primary: {
                main: '#89B219',
            },
        },
    });

    const [searchInformation, setSearchInformation] = React.useState<ISearchChips>();

    const handleSearchChips = (searchInformation: ISearchChips) => {
        setSearchInformation(searchInformation);
    }



    const [showDownloadDialog, setShowDownloadDialog] = React.useState(false);
    const [showBulkVerifyDialog, setBulkVerifyDialog] = React.useState(false);

    async function downloadReport() {
        try {
            let r = [...rows].filter(r => r.is_ordered === 0).map(r => {
                let z = { ...r };
                delete z['id'];
                return z;
            });
            // let s = [header, ...r];

            const ws = XLSX.utils.json_to_sheet(r);
            const wb = XLSX.utils.book_new();
            XLSX.utils.book_append_sheet(wb, ws, 'Export');

            XLSX.writeFile(wb, "SeedToBeOrdered.xls"); // <-- just do it this way.
            // TODO: submit to server the ones that have now been printed

            // console.log(rows);

            // let data = { items: rows.filter((r: { is_ordered: number; }) => r.is_ordered === 0).map((x: { id: any; }) => x.id), value: 1 };
            // const resp = await axios.put(
            //     `/seeding/markOrdered`,
            //     data
            // );
            // console.log(resp);
        } catch (e: any) {
            console.log(e)
            alert(e.message);
        }
    }

    async function bulkMarkVerified() {
        console.warn("bulkMarkVerified not implemented");
        // return;

        try {
            // TODO: grab the ones that are selected and mark them as verified
            // let r = [...dataSource].filter(r => r.is_ordered === 1 && selectedRows.indexOf(r.id) > -1).map(r => {
            //     let z = {...r};
            //     delete z['id'];
            //     // r['truck'] = r['truck'].truck_number;
            //     return z;
            // });
            // let s = [header, ...r];

            let data = { items: rows.filter((r: { is_ordered: number; id: any; }) => r.is_ordered === 1 && selectionModal.indexOf(r.id) > -1).map((x: { id: any; }) => x.id), value: 2 };
            console.log(data);
            // return;
            const resp = await axios.put(
                `/seeding/markOrdered`,
                data
            );
            console.log(resp);
        } catch (e: any) {
            console.log(e)
            alert(e.message);
        }
    }



    let actionMenuButtons = [
        <ActionButton action={(e) => setShowDownloadDialog(true)} buttonLabel='DOWNLOAD SEED TO ORDER FILE'></ActionButton>,
        <ActionButton action={(e) => { }} buttonLabel='BULK VERIFY'></ActionButton>,
    ]


    return (
        <>
            <Dialog
                open={showDownloadDialog}
                onClose={() => setShowDownloadDialog(false)}
                aria-labelledby="alert-dialog-title"
                aria-describedby="alert-dialog-description"
            >
                <DialogTitle id="alert-dialog-title" style={{ textAlign: "center" }}>
                    Download Seed To Order File
                </DialogTitle>
                <DialogContent>
                    <DialogContentText>
                        Click Download to Download Seed To Order File
                    </DialogContentText>
                </DialogContent>
                <DialogActions>
                    <MUIButton onClick={() => downloadReport()} variant='contained' color='secondary' autoFocus fullWidth={true}>DOWNLOAD</MUIButton>
                    <MUIButton onClick={() => setShowDownloadDialog(false)} variant='contained' autoFocus fullWidth={true} >CLOSE</MUIButton>
                </DialogActions>
            </Dialog>
            <Dialog
                open={showBulkVerifyDialog}
                onClose={() => setBulkVerifyDialog(false)}
                aria-labelledby="alert-dialog-title"
                aria-describedby="alert-dialog-description"
            >
                <DialogTitle id="alert-dialog-title" style={{ textAlign: "center" }}>
                    Bulk Verify
                </DialogTitle>
                <DialogContent>
                    <DialogContentText id="alert-dialog-description">
                        Click Here to Verify All Selected Seed Orders
                    </DialogContentText>
                </DialogContent>
                <DialogActions>
                    <MUIButton onClick={() => bulkMarkVerified()} variant='contained' color='secondary' autoFocus fullWidth={true}>VERIFY</MUIButton>
                    <MUIButton onClick={() => setBulkVerifyDialog(false)} variant='contained' autoFocus fullWidth={true}>CLOSE</MUIButton>
                </DialogActions>
            </Dialog>
            <ActionMenu buttons={actionMenuButtons}></ActionMenu>
            <div style={{ display: 'flex', flexDirection: 'column', height: '100%' }}>
                <ThemeProvider theme={darkTheme}>
                    <SearchChips handleSearch={handleSearchChips}></SearchChips>
                </ThemeProvider>
                <div style={{
                    flexGrow: 1
                }}>
                    <CustomDataGrid
                        sx={{ backgroundColor: 'white' }}
                        className={"DataGrid"}
                        rows={rows}
                        columns={columns}
                        rowsPerPageOptions={[15]}
                        page={page}
                        pageSize={15}
                        onPageChange={((page: React.SetStateAction<number>, details: any) => {
                            setPage(page)
                        })}
                        checkboxSelection={true}
                        disableSelectionOnClick
                        // onCellEditCommit={onCellEditCommit}
                        selectionModel={selectionModal}
                    // onSelectionModelChange={setSelectionModal} //Put this back - Corey
                    />
                </div>
            </div>
        </>);
}